/**
 * Triggers a browser download for an already-encoded blob via a temporary
 * `<a download>` element. Shared by SettingsPanel's export and the flipbook
 * panel's export so the object-URL lifecycle (create → click → revoke) lives
 * in one place.
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // deferred revoke, matching packages/excalidraw/data/blob.ts
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
